<template>
  <LoadingScreen />
</template>

<script>
import * as Sentry from '@sentry/vue'

// components
import LoadingScreen from '@/components-v2/common/loading/LoadingScreen.vue'

// services
import cookie from '@/services/cookie'
import zohoSSOService from '@/api/zohoSSO'

export default {
  components: {
    LoadingScreen,
  },
  mounted() {
    this.handleAuthentication()
  },
  methods: {
    handleAuthentication() {
      const { serviceurl } = this.$route.query
      const token = cookie.getValue('ahaToken')

      if (!serviceurl) {
        this.redirectToLogin()
        return
      }

      if (token) {
        this.signInZoho(serviceurl)
      } else {
        this.redirectToZohoAuth(serviceurl)
      }
    },
    redirectToLogin() {
      this.$router.push({ name: 'login' })
    },
    redirectToZohoAuth(serviceurl) {
      let redirect = `${window.location.origin}/zoho-auth?serviceurl=${serviceurl}`
      redirect = encodeURIComponent(redirect)

      this.$router.push({
        name: 'login',
        query: {
          redirect,
        },
      })
    },
    async signInZoho(serviceurl) {
      try {
        const { signin_url } = await zohoSSOService.signInZoho({ serviceurl })

        window.location.href = signin_url
      } catch (error) {
        Sentry.captureException(error)
      }
    },
  },
}
</script>
